export default "__VITE_ASSET__BiZusfZi__"